import React, { useState } from 'react';
import * as Yup from 'yup';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  CircularProgress,
  Backdrop
} from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import axios from 'axios';
import { baseUrl } from '../../utils/constants';
import Controls from '../controls/Controls';
import { useClaimsContext } from '../../context/claims_context';
import { useConstantsContext } from '../../context/constants_context';

export default function ClaimsSearch() {
  const { setProviderList } = useConstantsContext();
  const { setClaimNo, setBatchNo, setCurrentBatch } = useClaimsContext();
  const [showList, setShowList] = useState(false);
  const [noOfRecords, setNoOfRecords] = useState(-1);
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const navigate = useNavigate();

  const PersonalDetailsSchema = Yup.object().shape({
    // providerName: Yup.string().max(50, 'Surname is too Long!')
  });

  const formik = useFormik({
    initialValues: {
      claimId: '',
      batchId: ''
    },
    enableReinitialize: true,
    validationSchema: PersonalDetailsSchema,
    onSubmit: (values) => {
      console.log('search provider', values);
      setShowList(false);
      search(values);
      // handleSearch(values);
    }
  });

  const recordsReturned = (data) => {
    console.log('check my data', data);
    if (data.length > 0) {
      setProviderList(data);
      setShowList(true);
      setNoOfRecords(data.length);
    } else {
      setNoOfRecords(0);
    }
  };

  const search = async (values) => {
    if (values.providerName === '' && values.providerId === '') {
      notifyPopup(`Please enter Criteria to Search e.g. Enter Provider Name!`, 'error');
      return;
    }
    console.log('values layer', values);
    let strValues = '';
    let searchKeys = 1;
    if (values.providerName !== '') {
      strValues = values.providerName;
      searchKeys = 1;
    }
    if (values.providerId !== '') {
      strValues = values.providerId;
      searchKeys = 2;
    }
    const config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      params: {
        searchKey: searchKeys,
        strValue: strValues,
        firstName: 'temp'
      }
    };
    setLoading(true);
    // clearContext();

    axios.get(`${baseUrl}/api/setting/searchadvanced`, config).then(
      (result) => {
        setLoading(false);
        if (result.data.totalRecordCount === 0) {
          setNoOfRecords(0);
          setShowList(false);
          notifyPopup(
            `No Members Found with Specified Criteria: ${result.replyMessage}`,
            'success'
          );
        } else {
          recordsReturned(result.data);
        }
      },
      (error) => {
        notifyPopup(`Fatal Error in Retrieving Members Search List!: ${error}`, 'error');
      }
    );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleBatchView = async () => {
    setNoOfRecords(-1);
    const batchIds = formik.values.batchId;
    if (batchIds === '') {
      notifyPopup(`Batch # Not Entered, please enter number to seach for!`, 'error');
      return;
    }
    setLoading(true);
    await axios(
      `${baseUrl}/api/claims/GetBatchReportDetails?reportType=1&batchId=${batchIds}`
    ).then(
      (result) => {
        setLoading(false);
        if (result.data.result === undefined || result.data.result === null) {
          setNoOfRecords(0);
          notifyPopup(
            `No claim with the search ID of ${batchIds} Exists.  Please try a differnt number!: `,
            'error'
          );
        } else if (result.data.result.length === 0) {
          setNoOfRecords(0);
          notifyPopup(
            `No claim with the search ID of ${batchIds} Exists.  Please try a differnt number!: `,
            'error'
          );
        } else {
          setBatchNo(result.data.result[0].batchID);
          setCurrentBatch(result.data.result[0]);
          openViewBatch(result.data.result[0].batch_No);
        }
      },
      (error) => {
        notifyPopup(`Error in Getting Claim!: ${error}`, 'error');
      }
    );
  };

  const handleClaimView = async () => {
    setNoOfRecords(-1);
    const claimIds = formik.values.claimId;
    if (claimIds === '') {
      notifyPopup(`Claim # Not Entered, please enter number to seach for!`, 'error');
      return;
    }
    setLoading(true);
    await axios(`${baseUrl}/api/claims/getClaimById?claimId=${claimIds}`).then(
      (result) => {
        setLoading(false);
        if (result.data.result === undefined || result.data.result === null) {
          setNoOfRecords(0);
          notifyPopup(
            `No claim with the search ID of ${claimIds} Exists.  Please try a differnt number!: `,
            'error'
          );
        } else {
          setClaimNo(formik.values.claimId);
          openView(formik.values.claimId);
        }
      },
      (error) => {
        notifyPopup(`Error in Getting Claim!: ${error}`, 'error');
      }
    );
  };

  const openView = (e) => {
    navigate(`/claims/claim/${e}`);
  };

  const openViewBatch = (e) => {
    navigate(`/claims/claimsSelect/${e}`);
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  return (
    <>
      <Card>
        <CardContent>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate>
              <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
                onClick={handleLoadingClose}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
              <Typography component="span" variant="h6" gutterBottom>
                Search for Claims
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={5}>
                  <Controls.Input name="claimId" label="Claim #" />
                </Grid>
                <Grid item xs={12} sm={5}>
                  <Controls.Input name="batchId" label="Batch #" />
                </Grid>
              </Grid>
              <Grid
                container
                margin={2}
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                <Grid item xs={12} sm={2}>
                  <Button
                    type="button"
                    variant="outlined"
                    startIcon={<ClearIcon />}
                    onClick={() => handleClaimView()}
                  >
                    Search Claim
                  </Button>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Button
                    type="button"
                    variant="outlined"
                    startIcon={<AddCircleOutlineIcon />}
                    onClick={() => handleBatchView()}
                  >
                    Search Batch
                  </Button>
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
        </CardContent>
      </Card>
      {showList === false && noOfRecords === 0 && (
        <div style={{ margin: '10px 300px', color: 'red', fontWeight: '800' }}>
          No Claim # exists for selected criteria of {formik.values.claimId} ...
        </div>
      )}
      <Controls.Notification notify={notify} setNotify={setNotify} />
    </>
  );
}
